import Cookies from "js-cookie";
import { Miljo, Sprak } from "./enums";

interface loggBody {
  melding: string;
  url: string;
  userAgent: string;
  kilde: string;
  niva: string;
}

declare global {
  interface Window {
    ENV: string;
  }
}

export const finnMiljo = (): Miljo => {
  const { hostname } = window.location;
  if (window.ENV && (Object.values(Miljo) as string[]).includes(window.ENV)) {
    return window.ENV as Miljo;
  }
  if (hostname.includes("localhost") || hostname.includes(".utv.")) {
    return Miljo.UTV;
  }
  if (hostname.includes(".test.")) {
    return Miljo.TEST;
  }
  return Miljo.PROD;
};

const logFeil = (melding: string, appnavn: string) => {
  const miljo = finnMiljo();
  let baseUrl: string;

  const loggBody: loggBody = {
    melding: melding,
    url: window.location.href,
    userAgent: navigator.userAgent,
    kilde: appnavn,
    niva: "ERROR",
  };

  switch (miljo) {
    case Miljo.PROD:
      baseUrl = "https://tekstapp.atlas.vegvesen.no";
      break;
    case Miljo.TEST:
      baseUrl = "https://tekstapp.test.atlas.vegvesen.no";
      break;
    case Miljo.UTV:
      baseUrl = "https://tekstapp.utv.atlas.vegvesen.no";
  }

  fetch(`${baseUrl}/api/apptekst/logging`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(loggBody),
  });
};

export const hentApptekster = async (appnavn: string) => {
  const sprak = Cookies.get("ForceLocale1") || Sprak.NO;
  const miljo = finnMiljo();
  const respons = await fetch(
    `https://tekstapp.atlas.vegvesen.no/api/apptekst?apper=${appnavn}&sprak=${sprak}&miljo=${miljo}`.toLowerCase(),
  );
  if (!respons.ok) {
    const feilmelding = await respons.text();
    logFeil(
      `App ${appnavn} klarte ikke å hente tekster for språk "${sprak}" i miljø ${miljo}. Status ${respons.status} ${respons.statusText}. Respons: ${feilmelding}`,
      appnavn,
    );
    throw new Error(
      `Kunne ikke hente tekster. Responsstatusen var ${respons.status} ${respons.statusText}. Feilmeldingen var:
      
      ${feilmelding}`,
    );
  }
  return respons.json();
};

export const hentApptekstBasertPaaNokkel = async (nokkel: string) => {
  const sprak = Cookies.get("ForceLocale1") || Sprak.NO;
  const miljo = finnMiljo();

  const respons = await fetch(
    `https://tekstapp.atlas.vegvesen.no/api/apptekst/nokkel/${nokkel}?sprak=${sprak}&miljo=${miljo}`.toLowerCase(),
  );
  if (!respons.ok) {
    const feilmelding = await respons.text();
    logFeil(
      `Klarte ikke å hente tekst for nøkkel ${nokkel} og språk "${sprak}" i miljø ${miljo}. Status ${respons.status} ${respons.statusText}. Respons: ${feilmelding}`,
      nokkel,
    );
    throw new Error(
      `Kunne ikke hente tekst. Responsstatusen var ${respons.status} ${respons.statusText}. Feilmeldingen var:
      
      ${feilmelding}`,
    );
  }
  return respons.json();
};
